import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SafePipe } from '@siza-staff-care/shared/pipes';
import { MultiButtonDialogComponentDialogModel } from './generic-dialogs.model';

@Component({
	standalone: true,
	template: `
		<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
			<h1 mat-dialog-title cdkDragHandle>{{ data.title }}</h1>
		</div>

		<div mat-dialog-content>
			@if (data.asHtml) {
				<p [innerHtml]="data.body | safe"></p>
			} @else {
				{{ data.body }}
			}
		</div>

		<div mat-dialog-actions align="end">
			@for (button of data.buttons; track button) {
				<button
					[color]="button.primary ? 'primary' : button.warn ? 'warn' : ''"
					(click)="onButton(button.value)"
					mat-stroked-button
				>
					{{ button.label }}
				</button>
			}
			<button (click)="onCancel()" mat-stroked-button>Cancel</button>
		</div>
	`,
	styles: [],
	imports: [CommonModule, MatButtonModule, DragDropModule, MatButtonModule, MatDialogModule, SafePipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiButtonDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<MultiButtonDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: MultiButtonDialogComponentDialogModel,
	) {}
	// // Update view with given values	}
	@HostListener('document:keydown', ['$event'])
	onKeydown(event: KeyboardEvent): void {
		const button = this.data.buttons.find((b) => b.shortcutKey === event.key);
		if (button) {
			this.dialogRef.close(button.value);
		}
	}

	onButton(value: string) {
		this.dialogRef.close(value);
	}

	onCancel() {
		this.dialogRef.close(null);
	}
}
